import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoLoteService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    find(id){
        return this._http.get(`${this._env}/sales/productbatch/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllByIdProduto (idProduto, situacao, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/assprodutolote/findallbyidproduto.json?situacao=${situacao}&order=${order}&column=${column}&page=${page}&limit=${limit}&idproduto=${idProduto}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    listAllByProductNaoAss (idProduto, column = 'descricao', order = 'asc', page = 0, limit = 50) {
        return this._http.get(`${this._env}/sales/product/listAllByProductNaoAss.json?order=${order}&column=${column}&page=${page}&limit=${limit}&idproduto=${idProduto}`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(produtolote) {
        return this._http.post(`${this._env}/sales/product/assprodutolote/updatesituacao`, produtolote, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }
    
    save(lote) {
        return this._http.post(`${this._env}/sales/productbatch`, lote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}